import { Modal } from '@/ui/Modal'
import styles from './ConfirmDetailsModal.module.scss'
import { useGetConfirmDetails } from '../api/useGetConfirmDetails'
import { Loader } from '@/ui/Loader'
import { useGetUserInfo } from '@/modules/Auth'
import { ConfirmDetailsForm } from './ConfirmDetailsForm'
import { useModal } from '@/components/Modal'

export const ConfirmDetailsModal = () => {
    const { isLoading } = useGetConfirmDetails()
    const { isLoading: userInfoIsLoading } = useGetUserInfo()
    const { closeModal } = useModal()

    return (
        <Modal className={styles.modal} onClose={closeModal} hideCloseButton doNotCloseOnClickOutside>
            {isLoading || userInfoIsLoading ? <Loader /> : <ConfirmDetailsForm />}
        </Modal>
    )
}
